import React from 'react';

import './ContactOverview.css';

class ContactOverview extends React.Component {
    render() {
        return (
            <div id="contact" className='contactoverview_wrapper'>
                <div className="cSectionHead">
                    <h2>Sie möchten mich kennenlernen?</h2>
                    <a href="mailto:alex@viket.net" className="cBtn">
                        Alex@Viket.net
                    </a>
                </div>
            </div>
        );
    }
}

export default ContactOverview;


// WEBPACK FOOTER //
// ./src/ContactOverview/ContactOverview.react.js